import { useId } from 'react'
import { ApiError } from '@dss/api-client'
import { Button } from '@dss/design-system'
import { Link } from '../../lib/router'
import { usePortalCartContext } from './usePortalCartContext'

export function PortalCartContextSelector() {
  const context = usePortalCartContext()
  const id = useId()
  if (context.isLoading) return <span role="status">Проверяем доступ…</span>
  if (context.isError) return <div><p role="alert">{context.error instanceof ApiError
    && [401, 403].includes(context.error.status) ? 'Доступ к точкам не подтверждён.' : 'Не удалось загрузить доступные точки.'}</p>
    {!(context.error instanceof ApiError && [401, 403].includes(context.error.status))
      && <Button disabled={context.isFetching} onClick={() => void context.refetch()}>Повторить загрузку точек</Button>}
    <Link to="/me">Мои точки и доступ</Link></div>
  if (!context.data?.tradepoints.length) return <div><p>Торговые точки пока не назначены.</p>
    <Link to="/me">Мои точки и доступ</Link></div>
  if (!context.data.pairs.length) return <div><p>Для заказа нужно настроить плательщика точки.</p>
    <Link to="/me">Проверить точки и доступ</Link></div>
  const availablePointIds = new Set(context.data.pairs.map(pair => pair.tradepointId))
  return <div style={{ minWidth: 0, width: '100%' }}>
    <label htmlFor={id}>Торговая точка</label>
    <select id={id} value={context.pointId ?? ''} disabled={context.locked}
      style={{ width: '100%', minWidth: 0, minHeight: 44 }}
      onChange={event => context.selectPoint(event.target.value ? Number(event.target.value) : null)}>
      <option value="">Выберите точку доставки</option>
      {context.data.tradepoints.map(point => <option key={point.id} value={point.id}
        disabled={!availablePointIds.has(point.id)}>
        {point.name}{point.address ? ` — ${point.address}` : ''}
        {!availablePointIds.has(point.id) ? ' — плательщик не настроен' : ''}
      </option>)}
    </select>
    {context.data.tradepoints.some(point => !availablePointIds.has(point.id))
      && <p>Недоступные точки нельзя выбрать для заказа, пока менеджер не настроит плательщика.
        {' '}<Link to="/me">Проверить точки и доступ</Link></p>}
    {context.locked && <p><Link to="/cart">Завершите проверку заказа в корзине</Link></p>}
  </div>
}
